import React, { useMemo, useState, useEffect } from "react";
import DateFilter from "../../../Components/Date/DateFilter";
import { Table } from "../../../Components/Table/Table";
import { useParams } from "react-router-dom";
import { employeeLoginHistoryAPI } from "../../../api/attendance";
const Employeloginhistory = () => {
  const { id } = useParams(); // ✅ employee id

  const [pageno, setPageno] = useState(1);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);

useEffect(() => {
  fetchData();
}, [id, search, statusFilter, fromDate, toDate]);

const fetchData = async () => {
  try {
    const res = await employeeLoginHistoryAPI(id, {
      search,
      status: statusFilter,
      fromDate,
      toDate,
    });

    const formatted = res.data.map((item, index) => ({
      sno: index + 1,
      date: new Date(item.date).toLocaleDateString(),
      checkin: item.checkInTime
        ? new Date(item.checkInTime).toLocaleTimeString()
        : "-",
      checkout: item.checkOutTime
        ? new Date(item.checkOutTime).toLocaleTimeString()
        : "-",
      status: item.status,
      productionhour: item.productionHours || 0,
      createdAt: new Date(item.createdAt).toLocaleString(),
    }));

    setData(formatted);
  } catch (err) {
    console.error(err);
  }
};

  // ✅ FORMAT TABLE DATA
  const tableData = useMemo(() => {
    return data.map((item, index) => ({
      sno: index + 1,
      date: new Date(item.date).toLocaleDateString(),
      checkin: item.checkInTime
        ? new Date(item.checkInTime).toLocaleTimeString()
        : "-",
      checkout: item.checkOutTime
        ? new Date(item.checkOutTime).toLocaleTimeString()
        : "-",
      status: item.status,
      productionhour: item.productionHours || 0,
      createdAt: new Date(item.createdAt).toLocaleString(),
    }));
  }, [data]);

  const columns = useMemo(
    () => [
      { Header: "S.No", accessor: "sno" },
      { Header: "Date", accessor: "date" },
      { Header: "Check-In", accessor: "checkin" },
      { Header: "Check-Out", accessor: "checkout" },
      { Header: "Status", accessor: "status" },
      { Header: "Production Hours", accessor: "productionhour" },
      { Header: "Created At", accessor: "createdAt" },
    ],
    []
  );

  return (
    <div className="timesheet-container">
      <h2 className="timesheet-title">Employee Attendance History</h2>

      <div className="filter-bar">
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="All">All</option>
          <option value="Present">Present</option>
          <option value="Absent">Absent</option>
          <option value="Late">Late</option>
          <option value="Half Day">Half Day</option>
        </select>

        <DateFilter
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
      </div>

      <Table
        columns={columns}
        data={tableData}
        pageno={pageno}
        setPageno={setPageno}
        show
      />
    </div>
  );
};

export default Employeloginhistory;